export const showModeOptions = {
  DEFAULT: 'default',
  ONLY_LOW_SCORING: 'onlyLowScoring',
  ONLY_HIGH_SCORING: 'onlyHighScoring',
};
